import "./RoundFrame.scss";
import classNames from "classnames";

export function RoundFrame({ size, children, ...props })
{
    return (<div styleName={classNames("round-frame", size)} {...props}>
        <div styleName="contents">{children}</div>
    </div>);
}